import { useState } from "react";

const FORM_SUBMIT_ADDR = "https://readdy.ai/api/form/d9rhvs6e3oq4jqumu1k0";
const FORM_ID = "newsletter-subscription";

export default function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get("contact_alt") as string || "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("感谢订阅！");
      setEmail("");
      return;
    }

    setStatus("loading");
    try {
      const response = await fetch(FORM_SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ email } as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (response.ok && (parsed as { code?: string }).code === "OK") {
        setStatus("success");
        setMessage("订阅成功！感谢你的关注~");
        setEmail("");
      } else {
        const serverMsg = (parsed as { meta?: { message?: string } }).meta?.message
          || (parsed as { message?: string }).message
          || responseText;
        setStatus("error");
        setMessage(String(serverMsg || "订阅失败，请稍后重试"));
      }
    } catch {
      setStatus("error");
      setMessage("网络错误，请稍后重试");
    } finally {
      setTimeout(() => {
        setStatus("idle");
        setMessage("");
      }, 4000);
    }
  };

  return (
    <form onSubmit={handleSubmit} data-readdy-form="" id={FORM_ID} className="w-full max-w-md mx-auto">
      <div className="relative">
        <input
          type="email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="输入你的邮箱地址"
          required
          className="w-full h-12 pl-4 pr-32 rounded-full bg-background-50 border border-background-300 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
        />
        <button
          type="submit"
          disabled={status === "loading"}
          className="absolute right-1.5 top-1.5 h-9 px-5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors disabled:opacity-60 cursor-pointer whitespace-nowrap"
        >
          {status === "loading" ? "提交中..." : "订阅"}
        </button>
      </div>
      <input
        type="text"
        name="contact_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="h-0 w-0 absolute opacity-0 -z-10"
      />
      {message && (
        <p className={`mt-3 text-sm text-center ${
          status === "success" ? "text-accent-600" : "text-foreground-600"
        }`}>
          {message}
        </p>
      )}
    </form>
  );
}